import { useEffect, useRef, useState } from "react";

function useInView() {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold: 0.15 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return { ref, inView };
}

export default function About() {
  const { ref, inView } = useInView();

  return (
    <section id="nosotros" className="py-20 md:py-32 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Images */}
          <div className={`relative transition-all duration-700 ${inView ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="relative">
              <div className="w-full h-[420px] md:h-[520px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/2d33bedd18ef53dce70899e489672aff.jpg"
                  alt="Alonso Ashaika - Fundador"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating card */}
              <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#0A1F44] text-white rounded-xl p-5 shadow-xl max-w-[200px]">
                <div className="text-3xl font-bold text-[#D4AF37]" style={{ fontFamily: "'Playfair Display', serif" }}>15+</div>
                <div className="text-sm text-white/80 mt-1">Años transformando vidas en México</div>
              </div>
              {/* Golden accent */}
              <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#D4AF37]/40 rounded-xl pointer-events-none"></div>
            </div>
          </div>

          {/* Content */}
          <div className={`transition-all duration-700 delay-200 ${inView ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <span className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase">Sobre Nosotros</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0A1F44] mt-3 mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              El origen del problema<br />
              <span className="text-[#D4AF37]">está en lo invisible</span>
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6">
              El <strong>Instituto Ashaika</strong> nació de la visión de <strong>Alonso Ashaika</strong>, terapeuta y formador con más de 15 años de experiencia en terapias alternativas y desarrollo de conciencia. Su misión: crear un espacio donde la ciencia y la energía se unen para sanar desde la raíz.
            </p>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
              Somos la institución de referencia en México para la formación en <strong>Biomagnetismo Médico, Método Yuen, Hipnosis Terapéutica, Biotermodinamica Estrutural</strong> y más. Integramos múltiples técnicas en un enfoque holístico único que genera transformaciones reales y duraderas.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {[
                { icon: "ri-award-line", text: "Certificaciones reconocidas" },
                { icon: "ri-team-line", text: "Comunidad de más de 500 alumnos" },
                { icon: "ri-flask-line", text: "Enfoque científico-energético" },
                { icon: "ri-heart-pulse-line", text: "Resultados comprobados" },
              ].map((f) => (
                <div key={f.text} className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#D4AF37]/15 text-[#D4AF37] flex-shrink-0">
                    <i className={`${f.icon} text-base`}></i>
                  </div>
                  <span className="text-gray-700 text-sm font-medium">{f.text}</span>
                </div>
              ))}
            </div>

            <a
              href="https://wa.me/523325077743?text=Hola,%20quiero%20conocer%20más%20sobre%20el%20Instituto%20Ashaika"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#0A1F44] text-white font-semibold px-7 py-3.5 rounded-full hover:bg-[#0d2a5e] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Conoce más
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
